import { getCurrentStep, getSessionId, getIncompleteStep, getAuthXToken } from '@/services/auth'
import { NR_ABANDON_LOGIN_PROCESS, NR_STEPS, EMAIL_DOMAIN_SITEMINDER } from './constants'

/**
 * Tracks login process abandonment in New Relic.
 * Records when a user abandons the login process before completion.
 */
export const nrAbandonLoginProcess = (): boolean => {

  try {

    const authxToken = getAuthXToken()

    if (authxToken && authxToken.payload.email.includes(EMAIL_DOMAIN_SITEMINDER)) {
      return false
    }

    const sessionId = getSessionId()
    const incompleteStep = getIncompleteStep()
    const currentStep = incompleteStep ? incompleteStep : getCurrentStep()

    const newrelic: any = (window as any).newrelic

    // if user have a step or did not came from authenticated page
    // then user encountered an error or abandon the mfa registration, mfa authentication or login process
    if (newrelic && sessionId && currentStep && currentStep !== NR_STEPS.REDIRECT_TO_PRODUCT) {
      newrelic.addPageAction(NR_ABANDON_LOGIN_PROCESS, { sessionId, step: currentStep })
      return true
    }

    return false
  } catch {
    return false
  }
}
